import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CatalogItemCheckbox } from 'features/CatalogItemCheckbox';
import { DynamicTooltip } from 'shared/ui/Tooltip/ui/DynamicTooltip';

export interface CatalogItemCheckboxSectionProps {
    showQtyCheckbox: boolean;
    isActive: boolean;
    qty: number;
    itemIdToEdit: string | undefined;
    itemId: string;
    itemUid: string | undefined;
    quickEdit: boolean | undefined;
    isInOrder: boolean | undefined;
    showActionRequiredTooltip: boolean;
    onLearnMoreActionRequired: () => void;
}

interface ActionRequiredTooltipContentProps {
    onLearnMore: () => void;
}

const ActionRequiredTooltipContent = ({
    onLearnMore,
}: ActionRequiredTooltipContentProps) => {
    const { t } = useTranslation();
    return (
        <Box>
            <Typography
                variant="subtitle2"
                sx={{
                    fontWeight: 600,
                    marginBottom: '8px',
                }}
            >
                {t('Action Required')}
            </Typography>
            <Typography typography="openSans.caption" sx={{ mb: '8px' }}>
                {t(
                    // eslint-disable-next-line max-len
                    'To add this item to your property catalog, you need an active account with one of the suppliers below.',
                )}
            </Typography>
            <Link
                component="button"
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    onLearnMore();
                }}
                sx={{
                    color: 'inherit',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontSize: '12px',
                }}
            >
                {t('Learn more')}
            </Link>
        </Box>
    );
};

export const CatalogItemCheckboxSection = ({
    showQtyCheckbox,
    isActive,
    qty,
    itemIdToEdit,
    itemId,
    itemUid,
    quickEdit,
    isInOrder,
    showActionRequiredTooltip,
    onLearnMoreActionRequired,
}: CatalogItemCheckboxSectionProps) => {
    if (showActionRequiredTooltip) {
        return (
            <DynamicTooltip
                maxWidth={400}
                content={(closeTooltip) => (
                    <ActionRequiredTooltipContent
                        onLearnMore={() => {
                            onLearnMoreActionRequired();
                            closeTooltip();
                        }}
                    />
                )}
            >
                <Box>
                    <CatalogItemCheckbox
                        showQtyCheckbox={showQtyCheckbox}
                        isActive={false}
                        qty={qty}
                        itemIdToEdit={itemIdToEdit}
                        itemId={itemId}
                        itemUid={itemUid}
                        quickEdit={quickEdit}
                        isInOrder={isInOrder}
                        disabled
                    />
                </Box>
            </DynamicTooltip>
        );
    }

    return (
        <CatalogItemCheckbox
            showQtyCheckbox={showQtyCheckbox}
            isActive={isActive}
            qty={qty}
            itemIdToEdit={itemIdToEdit}
            itemId={itemId}
            itemUid={itemUid}
            quickEdit={quickEdit}
            isInOrder={isInOrder}
        />
    );
};
